import { useState, PropsWithChildren, useMemo, FC } from 'react';
import { IDemandDocumentParser } from '@api/settings/model/types.ts';
import DemandDocumentParserContext from '@providers/DocumentParserProvider/model/DocumentParserProviderContext.ts';

const DemandDocumentParserProvider: FC<PropsWithChildren> = ({ children }) => {
  const [demandDocumentParser, setDemandDocumentParser] =
    useState<IDemandDocumentParser | null>(null);

  const updateDemandDocumentParser = (data: IDemandDocumentParser) => {
    setDemandDocumentParser(data);
  };
  const defaultValues = useMemo(
    () => ({
      demandDocumentParser,
      setDemandDocumentParser,
      updateDemandDocumentParser,
    }),
    [demandDocumentParser, setDemandDocumentParser, updateDemandDocumentParser]
  );

  return (
    <DemandDocumentParserContext.Provider value={defaultValues}>
      {children}
    </DemandDocumentParserContext.Provider>
  );
};
export default DemandDocumentParserProvider;
